import { TextFieldProps } from '@forgeglobal/design-framework';
import { MaskitoOptions } from '@maskito/core';
import { FieldRenderProps } from 'react-final-form';
import MaskedTextField from '../MaskedTextField';

const options: MaskitoOptions = {
  mask: [
    ...new Array(3).fill(/\d/),
    '-',
    ...new Array(2).fill(/\d/),
    '-',
    ...new Array(4).fill(/\d/),
  ],
};

const SsnTextField = (
  props: TextFieldProps<any>
): React.ReactElement<FieldRenderProps<any, HTMLInputElement>> => {
  return (
    <MaskedTextField {...props} placeholder="___-__-____" options={options} />
  );
};

export default SsnTextField;
